import { IconButton, Stack, Typography } from "@mui/material";
import { ReuseTooltip } from "components/ui";
import { ReactNode } from "react";
import { UpdateKeyTitle } from "../../../../../types/apiTypes";
import {
  DeleteIcon,
  DragFieldIcon,
  StarIcon,
  StarWithBorderIcon,
} from "../../../../images";
import { ItemType } from "./SortableList";

type ItemProps = {
  item: ItemType;
  children: ReactNode;
  isIgnored: boolean;
};

const Item = ({ item, children, isIgnored }: ItemProps) => {
  const { id, isAdded, name } = item;
  return (
    <Stack flexDirection="row" gap="4px" data-id={id}>
      <Stack
        sx={{
          padding: "4px",
          borderRadius: "6px",
          backgroundColor: isIgnored
            ? isAdded
              ? "transparent"
              : "#F2D7D5"
            : isAdded
              ? "transparent"
              : "#F4F5F7",
          flexDirection: "row",
          alignItems: "center",
          flex: 1,
          border: isAdded
            ? `1px solid ${isIgnored ? "#F2D7D5" : "#DEDEDE"}`
            : "none",
        }}
      >
        <Stack
          sx={{
            cursor: "grab",
            flexDirection: "row",
            alignItems: "center",
            gap: "4px",
          }}
        >
          <DragFieldIcon color={isIgnored ? "#D98880" : "#353535"} />

          <Typography
            component="span"
            variant="body1"
            color="custom.textDarkBlue"
            sx={{
              whiteSpace: "nowrap",
              fontWeight: 500,
            }}
          >
            {name}
          </Typography>
        </Stack>

        <Stack flexDirection="row" flexWrap="nowrap" paddingLeft="4px">
          {children}
        </Stack>
      </Stack>
    </Stack>
  );
};

const iconStyles = {
  height: "16px",
  width: "16px",
};

const iconButtonStyles = {
  height: "24px",
  width: "24px",
  padding: "0px",
};

type Props = {
  item: ItemType;
  changeHandler: (data: Omit<UpdateKeyTitle, "campaign_id">) => void;
  removeHandler: (id: string) => void;
  isIgnored?: boolean;
};

export const TitleItem = ({
  item,
  changeHandler,
  removeHandler,
  isIgnored = false,
}: Props) => {
  const { is_critical, id } = item;
  return (
    <Item item={item} isIgnored={isIgnored}>
      {!isIgnored && (
        <ReuseTooltip
          text={
            is_critical
              ? "Unmark job title as critical"
              : "Mark job title as critical"
          }
        >
          <IconButton
            className="no-drag"
            sx={iconButtonStyles}
            onClick={() =>
              changeHandler({
                id: id,
                is_critical: !is_critical,
                position: !is_critical ? 0 : undefined,
              })
            }
          >
            {is_critical ? (
              <StarIcon {...iconStyles} color="#1D3E70" />
            ) : (
              <StarWithBorderIcon {...iconStyles} color="rgba(0, 0, 0, 0.3)" />
            )}
          </IconButton>
        </ReuseTooltip>
      )}

      <ReuseTooltip text="Delete job title">
        <IconButton
          className="no-drag"
          sx={iconButtonStyles}
          onClick={() => removeHandler(id)}
        >
          <DeleteIcon
            {...iconStyles}
            color={isIgnored ? "#D98880" : "#9B9B9B"}
          />
        </IconButton>
      </ReuseTooltip>
    </Item>
  );
};
